module.exports = __webpack_public_path__ + "img/verivox-64x64.ae9f2613.png";